<template>
  <div class="app-main-inner">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" :label-width="isZh ? '80px' : '125px'" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item :label="labelName">
              <!--起运港/目的港 (海运)-->
              <cargo-advance-select
                v-if="(criteriaType === 2 || criteriaType === 3) && ( seaLobArray.includes(lob) )"
                no="Seaport"
                filterable
                :multiple="true"
                :default-multiple-value="criteriaValues"
                :select-type="selectTypeNames.basic_data_Seaport"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                :clear-not-match="true"
                style="width: 100%"
                @parentCallBack="getValueFromChild"
              />
              <!--起运港/目的港 (空运)-->
              <cargo-advance-select
                v-if="(criteriaType === 2 || criteriaType === 3) && (airLobArray.includes(lob))"
                no="Airport"
                filterable
                :multiple="true"
                :default-multiple-value="criteriaValues"
                :select-type="selectTypeNames.basic_data_Airport"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                :clear-not-match="true"
                style="width: 100%"
                @parentCallBack="getValueFromChild"
              />
              <!--起运港/目的港 (铁路)-->
              <cargo-advance-select
                v-if="(criteriaType === 2 || criteriaType === 3) && (railLobArray.includes(lob))"
                no="RailwayStation"
                filterable
                :multiple="true"
                :default-multiple-value="criteriaValues"
                :select-type="selectTypeNames.basic_data_RailwayStation"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                :clear-not-match="true"
                style="width: 100%"
                @parentCallBack="getValueFromChild"
              />
              <!--承运人 海运-->
              <cargo-advance-select
                v-if="criteriaType === 1 && (seaLobArray.includes(lob))"
                no="SeaCmp"
                filterable
                :multiple="true"
                :default-multiple-value="criteriaValues"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true, active: true}"
                :custom-label="(item)=>`${item.chineseName}`"
                :show-custom-label-in-option="true"
                style="width: 205px"
                @parentCallBack="getValueFromChild"
              />
              <!--承运人 空运-->
              <cargo-advance-select
                v-if="criteriaType === 1 && (airLobArray.includes(lob))"
                no="AirCmp"
                filterable
                :multiple="true"
                :default-multiple-value="criteriaValues"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{airCmp:true, active: true}"
                :custom-label="(item)=>`${item.chineseName}`"
                :show-custom-label-in-option="true"
                style="width: 205px"
                @parentCallBack="getValueFromChild"
              />
              <!-- 航线/区域-->
              <cargo-advance-select
                v-if="criteriaType === 4"
                no="Region"
                filterable
                :multiple="true"
                :default-multiple-value="criteriaValues"
                :select-type="selectTypeNames.basic_data_Region"
                :callback-params="{key:'region'}"
                callback-method-type="value"
                style="width: 205px"
                @parentCallBack="getValueFromChild"
              />
              <!-- 国家-->
              <cargo-advance-select
                v-if="criteriaType === 5"
                no="BookingAgent"
                filterable
                :multiple="true"
                :default-multiple-value="criteriaValues"
                options-width="250px"
                :select-type="selectTypeNames.basic_data_Country"
                style="width: 205px"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item>
              <el-button no="Add" type="primary" @click="add">{{ $t('CargoMsg.Cargo_add') }}</el-button>
              <el-button no="Delete" type="danger" @click="remove">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height: 400px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import lodash from 'lodash'
import ColumnUtils from '@/utils/ColumnUtils'
import { CARRIER, POL, POD, REGION, COUNTRY } from '@/class/cargo/model/parameters/SystemConstants'

export default {

  name: 'CabinGroupTab',
  components: { cargoAdvanceSelect },
  props: {
    groupName: { type: String, required: true }, // 起运港:'POL' , 目的港:'POD'
    detailValue: { type: Array, default: null },
    status: { type: String, required: true },
    isNeedChangePort: { type: Boolean, default: false },
    lob: { type: String, default: '' }
  },
  data() {
    return {
      seaPortList: [],
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true,
          suppressMenu: true
        },
        pagination: false
      },
      rowData: [],
      originRowData: [],
      // 起运港ChargeSchemeConstants.CRITERIA_POL
      polColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return this.portCellRenderHandler(params.value)
          }
        }
      ],
      // 目的港
      podColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return this.portCellRenderHandler(params.value)
          }
        }
      ],
      // 承运人
      carrierColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      // 航线/区域
      RegionColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ShippingRouteArea'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Region, 'code', params.value, 'name')
          }
        }
      ],
      countryColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Country'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Country, 'code', params.value, 'chineseName')
          }
        }
      ],
      criteriaValues: [],
      seaLobArray: ['', 'IE', 'SE', 'SI', 'FBA_SE'],
      airLobArray: ['AE', 'AI', 'FBA_AE'],
      railLobArray: ['RE', 'RI', 'FBA_RE']
    }
  },
  computed: {
    isZh() {
      return this.$i18n.locale === 'zh'
    },
    columnDefs() {
      switch (this.groupName) {
        case CARRIER.englishName:
          return this.carrierColumnDefs
        case POL.englishName:
          return this.polColumnDefs
        case POD.englishName:
          return this.podColumnDefs
        case REGION.englishName:
          return this.RegionColumnDefs
        case COUNTRY.englishName:
          return this.countryColumnDefs
        default:
          return []
      }
    },
    labelName() {
      switch (this.groupName) {
        case CARRIER.englishName:
          return this.$t('CargoMsg.Cargo_Carrier')
        case POL.englishName:
          return this.$t('CargoMsg.Cargo_PortOfLoading')
        case POD.englishName:
          return this.$t('CargoMsg.Cargo_DestinationPort')
        case REGION.englishName:
          return this.$t('CargoMsg.Cargo_ShippingRouteArea')
        case COUNTRY.englishName:
          return this.$t('CargoMsg.Cargo_Country')
        default:
          return ''
      }
    },
    criteriaType() {
      //  1, 承运人 2,起运港 POL 3, 目的港 , POD 4,航线 5 国家
      switch (this.groupName) {
        case CARRIER.englishName:
          return 1
        case POL.englishName:
          return 2
        case POD.englishName:
          return 3
        case REGION.englishName:
          return 4
        case COUNTRY.englishName:
          return 5
        default:
          return 0
      }
    }
  },
  watch: {
    async status(val) {
      this.created()
    },
    isNeedChangePort(val) {
      if (val && (this.criteriaType === 3 || this.criteriaType === 4)) {
        this.rowData = []
      }
    }
  },
  async created() {
    if (['edit'].includes(this.status)) {
      this.rowData = this.detailValue
    }
    this.rowData = this.filterTableData(this.rowData)
    this.originRowData = lodash.cloneDeep(this.rowData)
  },
  methods: {
    filterTableData(data) {
      return data.filter(item => item.waitDealStatus !== 'delete')
    },
    getValueFromChild(obj) {
      this.criteriaValues = obj.value ? obj.value : []
    },
    add() {
      if (this.criteriaValues.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.labelName)
        return
      }
      const self = this
      const existingValues = new Set(this.rowData.map(row => String(row.criteriaValue)))
      const newValues = this.criteriaValues.filter(value => !existingValues.has(String(value)))

      if (newValues.length === 0) {
        this.$message.warning(self.$t('common.tips.repeatedlyTip'))
      } else {
        newValues.push()
        newValues.forEach(value => {
          this.rowData.push({ criteriaValue: value })
        })
        this.notifyParent()
      }
      this.criteriaValues = []
    },
    remove() {
      if (this.rowData.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (selectedRow) {
        const index = this.rowData.findIndex(row => row.criteriaValue === selectedRow.criteriaValue)
        if (index > -1) {
          this.rowData.splice(index, 1)
          this.gridOptions.api.refreshCells({ force: true })
          this.notifyParent()
        }
        this.gridOptions.api.clearFocusedCell()
      } else {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
      }
    },
    // 筛选出新增&和删除项并返还给父组件
    notifyParent() {
      let addRow = []
      if (this.rowData && this.rowData.length > 0) {
        if (this.originRowData && this.originRowData.length > 0) {
          // 原列表没有，但rowData中有的数据，视为新增
          this.rowData.forEach(row => {
            const newRow = this.originRowData.find(originRow => originRow.criteriaValue === row.criteriaValue)
            if (!newRow) {
              addRow.push(row)
            }
          })
        } else {
          addRow = [...this.rowData]
        }
      }
      let delRow = []
      if (this.originRowData && this.originRowData.length > 0) {
        if (this.rowData && this.rowData.length > 0) {
          delRow = this.originRowData.filter(originRow => {
            const rows = this.rowData.filter(row => {
              return originRow.criteriaValue === row.criteriaValue
            })
            return rows.length < 1
          })
        } else {
          delRow = this.originRowData
        }
      }
      const rows = []
      addRow.forEach(row => {
        rows.push({
          criteriaType: this.criteriaType,
          criteriaValue: row.criteriaValue,
          waitDealStatus: 'add'
        })
      })
      delRow.forEach(row => {
        rows.push({
          uuid: row.uuid,
          criteriaType: this.criteriaType,
          criteriaValue: row.criteriaValue,
          waitDealStatus: 'delete'
        })
      })
      this.$emit('func', rows)
    },
    portCellRenderHandler(value) {
      let result = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Seaport, 'code', value, 'englishName')
      if (!result) {
        result = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Airport, 'code', value, 'englishName')
      }
      if (!result) {
        result = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_RailwayStation, 'code', value, 'chineseName')
      }
      return result || ''
    }
  }
}
</script>
